import { render, staticRenderFns } from "./BtnDetalhesIndicacao.vue?vue&type=template&id=46f90e6d&"
import script from "./BtnDetalhesIndicacao.vue?vue&type=script&lang=js&"
export * from "./BtnDetalhesIndicacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports